import { LicenseInfo } from '@mui/x-license-pro';

export const muiPro = () => LicenseInfo.setLicenseKey('31978adf168865aba9d1502a443edb31Tz0xMzA0ODksRT0xODE3ODU1OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=');
